import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { LoginTranslationEnglish, LoginTranslationSouthernTutchone } from './components/Login/_internationalization';
import { NavigationBarEnglish, NavigationBarSouthernTutchone } from './components/NavigationBar/_internationalization';

// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    lng: 'en',
    fallbackLng: 'en',
    debug: true,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      en: {
        translation: {
          ...LoginTranslationEnglish,
          ...NavigationBarEnglish,
        },
      },
      southernTutchone: {
        translation: {
          ...LoginTranslationSouthernTutchone,
          ...NavigationBarSouthernTutchone,
        },
      },
    },
  });

export default i18n;
